import { create } from 'zustand';

import { queryClient } from '@/api/queryClient.ts';
import { getContacts, removeContact } from '@/store/contacts/contacts.api.ts';
import type { PersonContactResponse } from '@/store/contacts/contacts.dto.ts';
import { toast } from '@/utils/toast.ts';

type ContactsType = {
  contacts: PersonContactResponse[];
  /** The list has answered once (or failed to), so a missing entry is really missing. */
  loaded: boolean;
  getContacts: () => Promise<void>;
  removeContact: (id: string) => Promise<void>;
};

export const useContacts = create<ContactsType>((set, get) => ({
  contacts: [],
  loaded: false,
  getContacts: async () => {
    try {
      const response = await queryClient.fetchQuery({
        queryKey: ['contacts'],
        queryFn: getContacts,
      });
      set({ contacts: response?.data.items });
    } catch {
      toast.error('Couldn’t load your contacts. Please try again.');
    } finally {
      set({ loaded: true });
    }
  },
  removeContact: async (id) => {
    try {
      await removeContact(id);
      await queryClient.invalidateQueries({ queryKey: ['contacts'] });
      await get().getContacts();
    } catch {
      toast.error('Couldn’t remove the contact. Please try again.');
    }
  },
}));
